import endpoints from "hooks/api/endpoints";
import useApiGet from "hooks/api/useApiGet";
import IndividualItemResponse from "types/IndividualItemResponse";
import ShareFromTokenDto from "types/ShareFromTokenDto";

export default function useGetShareByTokenId(tokenId: string | undefined) {
  const { result, ...rest } = useApiGet<
    IndividualItemResponse<ShareFromTokenDto>
  >(tokenId ? endpoints.getShareFromToken(tokenId) : "");

  return {
    shareVideos: result?.data.shareVideos,
    ...rest,
  };
}
